import { OfferingDocument, OfferingDocumentType } from '@arrived/models';

const VALID_FINANCIAL_DOCUMENTS = [OfferingDocumentType.FORM_1K, OfferingDocumentType.FORM_1SA];

export const filterPropertyFinancialDocuments = (documents: OfferingDocument[], returnFinancials = true) => {
  return returnFinancials
    ? documents.filter((document) => VALID_FINANCIAL_DOCUMENTS.some((docType) => document.type === docType))
    : documents.filter((document) => VALID_FINANCIAL_DOCUMENTS.every((docType) => document.type !== docType));
};
